










import {
  defineComponent,
  ref,
  watch,
} from '@vue/composition-api';
import type { Ref } from '@vue/composition-api';

import {
  Chart, registerables,
} from 'chart.js';
import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';

Chart.register(...registerables);
Chart.register(TreemapController, TreemapElement);
Chart.defaults.font.family = 'Kanit, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
Chart.defaults.plugins.legend.align = 'start';
Chart.defaults.plugins.legend.position = 'bottom';
Chart.defaults.datasets.bar.maxBarThickness = 80;

const ChartJS = defineComponent({
  props: {
    type: {
      type: String,
      default: 'bar',
    },
    data: {},
    options: {},
    height: {},
    width: {},
  },
  setup(props, { emit, listeners }) {
    const chartElm = ref(null);
    const chartObj: Ref<any> = ref(null);

    function rerenderChart() {
      chartObj.value.update();
    }

    watch(() => chartElm.value, (newVal, oldVal) => {
      if (newVal !== oldVal && newVal) {
        chartObj.value = new Chart(chartElm.value as any, {
          type: props.type as any,
          data: props.data as any,
          options: props.options,
        });
      }
    });

    watch(() => props.data, (newVal, oldVal) => {
      if (newVal !== oldVal && chartObj.value) {
        chartObj.value.data = props.data;
        rerenderChart();
      }
    });
    watch(() => props.options, (newVal, oldVal) => {
      if (newVal !== oldVal && chartObj.value) {
        chartObj.value.options = props.options;
        rerenderChart();
      }
    });

    function emitWheel(e: WheelEvent) {
      if ('wheel' in listeners) {
        e.preventDefault();
        emit('wheel', e);
      }
    }

    function updateY(direction = 1) {
      chartObj.value.config.options.scales.y.min += direction;
      chartObj.value.config.options.scales.y.max += direction;
    }

    function updateX(direction = 1) {
      chartObj.value.config.options.scales.x.min += direction;
      chartObj.value.config.options.scales.x.max += direction;
    }

    function setMaxY(max: number) {
      if (chartObj.value) {
        chartObj.value.config.options.scales.y.max = max;
      }
    }
    function setMinY(min: number) {
      if (chartObj.value) {
        chartObj.value.config.options.scales.y.min = min;
      }
    }

    return {
      chartElm,
      emitWheel,
      rerenderChart,
      updateX,
      updateY,
      setMaxY,
      setMinY,
    };
  },
});

export default ChartJS;
